import BottomSheet from 'components/BottomSheet';
import Icon from 'components/Icon';
import React from 'react';
import Form from './Form';

type AppProps = {
  open: boolean;
  closeModal: () => any;
  rooftemplateId?: string;
};

const CreateTemplate: React.FC<AppProps> = ({
  open,
  closeModal,
  rooftemplateId,
}) => {
  return (
    <BottomSheet open={open} maxWidth="max-w-3xl">
      <div className="pb-4">
        <div className="flex justify-between">
          <div className="page-heading">
            {rooftemplateId ? 'Edit Rooftemplate' : 'Create Rooftemplate'}
          </div>
          <div>
            <Icon
              name="close"
              size={32}
              onClick={closeModal}
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>
      <Form rooftemplateId={rooftemplateId} closeModal={closeModal} />
    </BottomSheet>
  );
};

export default CreateTemplate;
